import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class ScrollRevealController extends BridgeComponent {
  static component = "title-opacity";

  static values = {
    start: Number,
    end: Number,
    target: String
  }

  connect() {
    if (this.hasTargetValue) {
      this.targetElement = document.querySelector(this.targetValue);
    } else {
      this.targetElement = window;
    }

    this.targetElement.addEventListener("scroll", this.scroll.bind(this));
    this.send('connecct', { opacity: 0.0});
  }

  scroll() {
    const start = this.startValue;
    const end = this.endValue;
    const scrollY = this.targetElement.scrollY;
    let progress = Math.min(Math.max((scrollY - start) / (end - start), 0), 1);
    this.send('scroll', { opacity: progress });

  }
}